import React from 'react';

const ROLES = {
  admin: { level: 100, label: 'Administrator', color: 'purple', description: 'Full system access. Can manage everything including roles and passwords.' },
  manager: { level: 90, label: 'Manager', color: 'blue', description: 'Can manage employees, billing, and all operational data.' },
  supervisor: { level: 75, label: 'Supervisor', color: 'cyan', description: 'Can oversee operations but limited financial access.' },
  line_crew: { level: 30, label: 'Line Crew', color: 'green', description: 'Can process fuel sales and view aircraft/hangar data.' },
  dispatcher: { level: 25, label: 'Dispatcher', color: 'yellow', description: 'Can coordinate operations and view schedules.' },
  accountant: { level: 20, label: 'Accountant', color: 'orange', description: 'Can manage invoices and financial reports.' },
  cashier: { level: 20, label: 'Cashier', color: 'orange', description: 'Can process payments and generate invoices.' },
  basic_user: { level: 10, label: 'Basic User', color: 'gray', description: 'Standard user access to assigned modules.' },
  customer: { level: 10, label: 'Customer', color: 'gray', description: 'Client access to own data only.' },
  read_only: { level: 5, label: 'Read Only', color: 'gray', description: 'Can only view data, no modifications allowed.' },
};

const RolesPermissions = ({ currentUserRole }) => {
  return (
    <div className="bg-gray-800/50 rounded-xl border border-gray-700 overflow-hidden p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-white">Roles & Permissions</h3>
          <p className="text-gray-400 text-sm">Define what each role can access and do in the system</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {Object.entries(ROLES).map(([key, { label, level, color, description }]) => (
          <div key={key} className={`bg-${color}-500/10 border border-${color}-500/20 rounded-lg p-4`}>
            <div className={`text-${color}-400 font-semibold mb-1`}>{label}</div>
            <div className="text-xs text-gray-500">Level: {level}</div>
            <div className="text-xs text-gray-400 mt-2">{description}</div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-500/10 border border-blue-500/20 rounded-lg">
        <h4 className="text-blue-400 font-semibold mb-2">How Roles Work</h4>
        <ul className="text-sm text-gray-300 space-y-1">
          <li>• <strong>Hierarchical</strong> - Higher level roles inherit permissions from lower levels</li>
          <li>• <strong>Custom Overrides</strong> - Individual employees can have custom permissions overrides</li>
          <li>• <strong>Audit Trail</strong> - All role changes are logged for security compliance</li>
          <li>• <strong>Least Privilege</strong> - Follows security best practices - grant minimum necessary access</li>
          <li>• <strong>Password Management</strong> - Only level 100 (Admin) can change employee passwords</li>
        </ul>
      </div>
    </div>
  );
};

export default RolesPermissions;